import React from 'react'
import PropTypes from 'prop-types'
import NavigationArrow from './NavigationArrow'

import './style.css.scss'

const NAVIGATION_ARROWS_SIDES = {
  left: "left",
  right: "right"
}

const NavigationPanel = ({
  className,
  onNextItemHover,
  onNextItem,
  onPrevItem,
  nextItem,
  prevItem
}) => {
  return (
    <div className={`navigation-panel ${className}`}>
      <NavigationArrow
        side={NAVIGATION_ARROWS_SIDES.left}
        onClick={onPrevItem}
        item={prevItem} />
      <NavigationArrow
        onHover={onNextItemHover}
        side={NAVIGATION_ARROWS_SIDES.right}
        onClick={onNextItem}
        item={nextItem} />
    </div>
  )
}

NavigationPanel.propTypes = {
  onNextItemHover: PropTypes.func.isRequired,
  onNextItem: PropTypes.func.isRequired,
  onPrevItem: PropTypes.func.isRequired,
  nextItem: PropTypes.object,
  prevItem: PropTypes.object,
  className: PropTypes.string
}

NavigationPanel.defaultProps = {
  className: ""
}

export default NavigationPanel
